import { useSelector, useDispatch } from "react-redux";
import BlogCard from "./components/BlogCard";
import Header from "./components/Header";
import {
    authorpostsearched,
    categorysearched,
    searched,
} from "./redux/filters/actions";

const App = () => {
    const dispatch = useDispatch();
    const input = useSelector((state) => state.filter.input);
    const category = useSelector((state) => state.filter.categoryInput);
    const author = useSelector((state) => state.filter.authorInput);
    const blogs = useSelector((state) => state.blog);

    // search blog filter
    const searchBlog = (item) => {
        return item.title
            .toLocaleLowerCase()
            .includes(input.toLocaleLowerCase());
    };

    // search category filter
    const searchCategory = (item) => {
        if (category !== "") {
            if (item.category === category) {
                return item;
            }
        } else {
            return item;
        }
    };

    // search author filter
    const searchAutor = (item) => {
        if (author !== "") {
            if (item.author.name === author) {
                return item;
            }
        } else {
            return item;
        }
    };

    // clear all filters
    const clearFilter = () => {
        dispatch(searched(""));
        dispatch(categorysearched(""));
        dispatch(authorpostsearched(""));
    };

    return (
        <>
            <Header />
            <section className="relative pt-8 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8">
                <div className="absolute inset-0">
                    <div className="bg-white h-1/3 sm:h-2/3"></div>
                </div>
                <div className="relative max-w-7xl mx-auto">
                    <div className="text-center">
                        <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
                            ALL BLOGS ARE HERE
                        </h2>
                        <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
                            Lorem ipsum dolor sit amet consectetur, adipisicing
                            elit. Ipsa libero labore natus atque, ducimus sed.
                        </p>
                    </div>
                    {input !== "" || category !== "" || author !== "" ? (
                        <div className="flex items-center justify-end ">
                            <button
                                onClick={clearFilter}
                                className="h-10 px-8 text-white bg-red-500 rounded-full text-sm hover:bg-red-600 delay-100"
                            >
                                Clear Filter
                            </button>
                        </div>
                    ) : (
                        ""
                    )}
                    <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
                        {blogs
                            .filter(searchBlog)
                            .filter(searchCategory)
                            .filter(searchAutor)
                            .map((item, index) => {
                                return <BlogCard key={index} item={item} />;
                            })}
                    </div>
                </div>
            </section>

            <section className="pt-6">
                <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex justify-between gap-2 border-t text-sm text-slate-400">
                    <div>Copyright 2022 Learn with Sumit.</div>
                    <div>
                        <a
                            href="https://youtube.com/learnwithsumit"
                            target="_blank"
                            rel="noreferrer"
                        >
                            YouTube Channel
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
};

export default App;
